import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      display: "flex",
      flexDirection: "row",
      userSelect: "none",
    },
    left: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      flexGrow: 1,
    },
    right: {
      flexShrink: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    logo: {
      width: 35,
      height: 35,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: constants.radius.button,
      marginRight: spacing.xs,
      display: "flex",
    },
    name: {
      marginLeft: spacing.xxs,
    },
    cta: {
      cursor: "pointer",
      fontWeight: 600,
      color: theme.shared.cta.remove,
    },
    initials: {
      marginTop: 2,
      fontWeight: 700,
    },
  };

  return styles;
};
